import { UseQueryOptions } from "@oysterhr/core"
import { gql, useQuery } from "@apollo/client"
import { Query, QueryBenefitReconciliationRunsArgs } from "@oysterhr/schema"

const LATEST_RECONCILIATION_RUNS = gql`
  query BenefitsStaffReconciliatonRuns($providerId: ID, $page: Int, $perPage: Int) {
    benefitReconciliationRuns(providerId: $providerId, page: $page, perPage: $perPage) {
      collection {
        id
        status
        createdAt
        requester {
          id
          avatarUrl
          name
        }
        output {
          url
          title
          createdAt
        }
        input {
          url
          title
        }
      }
      metadata {
        totalCount
      }
    }
  }
`

export function useReconciliationRuns(
  options: UseQueryOptions<
    Pick<Query, "benefitReconciliationRuns">,
    QueryBenefitReconciliationRunsArgs
  >,
) {
  return useQuery(LATEST_RECONCILIATION_RUNS, {
    fetchPolicy: "network-only",
    ...options,
  })
}
